<div class="flex items-center">
  <input type="checkbox" class="h-4 w-4 text-indigo-500" [value]="value"
    [checked]="checked" (change)="onChange.emit($event)" />
  <p class="ml-2 text-sm">{{ title }}</p>
</div>